import classNames from 'classnames';
import React from 'react';
import css from './InlineSpinner.scss';

interface InlineSpinnerProps {
    size: string;
    className?: string | null;
}

const InlineSpinner: React.FC<InlineSpinnerProps> = (props) => (
    <React.Fragment>
        <div className={classNames([css.sp, css.spCircle, props.className])} style={{ width: props.size, height: props.size }} />
    </React.Fragment>
);
export default InlineSpinner;
